import { ActionTypes } from 'constants/index'

const initialState = {
    loading: {},
    data: {},
    error: {}
}

const jobReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SAVE_JOB: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: true
                }
            }
        }
        case ActionTypes.SAVE_JOB_SUCCESS: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: action.payload.data
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: null
                }
            }
        }
        case ActionTypes.SAVE_JOB_FAILURE: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: null
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: action.payload
                }
            }
        }

        case ActionTypes.GET_JOB: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: true
                }
            }
        }
        case ActionTypes.GET_JOB_SUCCESS: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: action.payload.data
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: null
                }
            }
        }
        case ActionTypes.GET_JOB_FAILURE: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: null
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: action.payload
                }
            }
        }

        case ActionTypes.EXECUTE_JOB: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: true
                }
            }
        }
        case ActionTypes.EXECUTE_JOB_SUCCESS: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: action.payload.data
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: null
                }
            }
        }
        case ActionTypes.EXECUTE_JOB_FAILURE: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.dataUniqueId]: false
                },
                data: {
                    ...state.data,
                    [action.payload.dataUniqueId]: null
                },
                error: {
                    ...state.error,
                    [action.payload.dataUniqueId]: action.payload
                }
            }
        }
        case ActionTypes.CLEAR_REDUX_DATA_OF_COMPONENT_IN_JOB_STORE: {
            let dataToClear = action.payload;
            let newState = structuredClone(state);
            if (Array.isArray(dataToClear.key)) {
                dataToClear.key.forEach(k => {
                    delete newState[k]
                })
            } else {
                let _document = newState[dataToClear.key];
                if (Array.isArray(dataToClear?.subKey)) {
                    dataToClear?.subKey?.forEach(key => {
                        delete _document[key];
                    })
                } else {
                    delete _document[dataToClear?.subKey]
                }
                newState[dataToClear.key] = _document
            }
            return newState;
        }
        default: {
            return state
        }
    }
}

export default jobReducer;